import styled from 'styled-components'

import { H2, H4, H6 } from '@components/Text'
import { Row, Col } from '@gympass/yoga'

import getBreakpoint from '@client/utils/breakpoints'

export const Title = styled(H2)`
  font-weight: 900;
  line-height: 37px;
  margin-top: 48px;

  @media (min-width: ${getBreakpoint('xl')}px) {
    margin-top: 80px;
  }
`

export const FormTitle = styled(H4)`
  font-weight: 900;
  line-height: 23px;
  margin-bottom: 8px;

  enum {
    font-weight: 400;
    margin-right: 4px;
  }
`

export const Subtitle = styled(H6)`
  font-style: normal;
  font-weight: normal;
  margin-top: 16px;
  margin-bottom: 48px;

  @media (min-width: ${getBreakpoint('md')}px) {
    margin-top: 8px;
    margin-bottom: 56px;
  }
`

export const Fieldset = styled.fieldset`
  margin-top: 64px;
  padding: 0;
  border: 0;
`

export const Divider = styled.hr`
  margin-top: 56px;
  margin-bottom: 56px;
  background: #dbdbe8;
  height: 1px;
  border: none;
`

export const Form = styled.form`
  & .MuiFormHelperText-root {
    color: var(--error);
  }

  ${Row}:first-of-type {
    ${Col}:first-of-type {
      .MuiFormControl-root:first-of-type {
        margin-top: 0px;

        @media (min-width: ${getBreakpoint('xl')}px) {
          margin-top: 24px;
        }
      }
    }
  }

  & .MuiFormControl-root {
    margin-top: 16px;

    @media (min-width: ${getBreakpoint('xl')}px) {
      margin-top: 24px;
    }
  }

  @media (min-width: ${getBreakpoint('xl')}px) {
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 0;
  }
`

export const ButtonWrapper = styled.section`
  display: flex;
  flex-direction: column;
  margin-top: 32px;
  margin-bottom: 64px;
  color: #1968c9;

  button:first-of-type {
    margin-bottom: 16px;
  }

  @media (min-width: ${getBreakpoint('xl')}px) {
    flex-direction: row-reverse;
    justify-content: space-between;
  }
`
